import { Endpiont, BaseURL } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list Product-------
const getAllProduct = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.product.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllProductQuery = (filter) => {
    return useQuery(['Product', filter], () => getAllProduct(filter));

};
// ------------------ list Shopify Product-------
const getShopifyProducts = async (filter) => {
    const { data } = await axios.get(BaseURL + Endpiont.shopify.products + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetShopifyProductQuery = (filter) => {
    return useQuery(['ShopifyProduct', filter], () => getShopifyProducts(filter));
};
// ------------------ Add Product-------
const addProduct = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.product.add, payload);
};
const AddProductMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Product');
            toastMessage('success', 'Product Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Delete Sub Category-------
const deleteProduct = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.product.delete + id);
};
const DeleteProductMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Product');
            toastMessage('success', 'Product Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Update Product-------
const updateProduct = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.product.update + id, payload);
};
const UpdateProductMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateProduct, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Product');
            toastMessage('success', 'Model / Product Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllProductQuery, AddProductMutation, DeleteProductMutation, UpdateProductMutation, GetShopifyProductQuery };
